import { useTranslations } from '@vocab/react';
import { Box, Checkbox, Stack } from 'braid-design-system';

import { FilterAccordion } from '../FilterAccordion/FilterAccordion';
import { SearchFilter } from '../SearchFilter/SearchFilter';
import type { Suggestion } from '../types';

import translations from './.vocab';

interface Props {
  expanded: boolean;
  selectedItems: Suggestion[];
  suggestions: Suggestion[];
  onRoleTitleChange: (newSelectedItems: Suggestion[]) => void;
  onExpandedToggle: (expanded: boolean) => void;
  matchLatestRoleTitle: boolean;
  onMatchLatestRoleTitleChange: (newState: boolean) => void;
  onDebouncedSearchTextChange: (newSearchText: string) => void;
  onSearchTextChange?: (newSearchText: string) => void;
}

export const RoleTitleFilter = ({
  expanded,
  selectedItems,
  suggestions,
  onRoleTitleChange,
  onExpandedToggle,
  matchLatestRoleTitle,
  onMatchLatestRoleTitleChange,
  onDebouncedSearchTextChange,
  onSearchTextChange,
}: Props) => {
  const { t } = useTranslations(translations);

  return (
    <FilterAccordion
      id="role-title-accordion-filter"
      expanded={expanded}
      label={t('ROLE_TITLE')}
      selectedItems={selectedItems}
      onToggle={onExpandedToggle}
    >
      <Stack space="small">
        <SearchFilter
          id="role-title-filter"
          label=""
          placeholder={t('ENTER_ROLE_TITLE_EG_MARKETING_MANAGER')}
          suggestions={suggestions}
          selectedItems={selectedItems}
          onDebouncedSearchTextChange={onDebouncedSearchTextChange}
          onSearchTextChange={onSearchTextChange}
          onChange={onRoleTitleChange}
        />
        <Box paddingLeft="xxsmall">
          <Checkbox
            size="small"
            id="role-title-filter-checkbox"
            label={t('MATCH_WITH_LATEST_ROLE_TITLE_ONLY')}
            checked={matchLatestRoleTitle}
            onChange={() => onMatchLatestRoleTitleChange(!matchLatestRoleTitle)}
          />
        </Box>
      </Stack>
    </FilterAccordion>
  );
};
